import store from '..';
import { Workflows } from '../../services';
import { createRestSlices, applyReducers } from './rest';

const {
    initialState,
    getReducer, listReducer, updateReducer, duplicateReducer,
    startCreateReducer, createReducer, deleteReducer,
    getAction, listAction, updateAction, duplicateAction,
    startCreateAction, createAction, deleteAction,
    linkedResourcesReducer, linkedResourcesAction
} = createRestSlices(Workflows);

const STARTING_WORKFLOW                  = 'kronos/workflows/STARTING_WORKFLOW';
const STARTING_WORKFLOW_SUCCESS          = 'kronos/workflows/STARTING_WORKFLOW_SUCCESS';
const STARTING_WORKFLOW_FAILURE          = 'kronos/workflows/STARTING_WORKFLOW_FAILURE';
const DONE_BRICK                         = 'kronos/workflows/DONE_BRICK';
const DONE_BRICK_SUCCESS                 = 'kronos/workflows/DONE_BRICK_SUCCESS';
const DONE_BRICK_FAILURE                 = 'kronos/workflows/DONE_BRICK_FAILURE';
const GET_BRICK_RESOURCES                = 'kronos/workflows/GET_BRICK_RESOURCES';
const GET_BRICK_RESOURCES_SUCCESS        = 'kronos/workflows/GET_BRICK_RESOURCES_SUCCESS';
const GET_BRICK_RESOURCES_FAILURE        = 'kronos/workflows/GET_BRICK_RESOURCES_FAILURE';

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case STARTING_WORKFLOW:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false,
                errorMessage: null,
                workflow: null
            };
        case STARTING_WORKFLOW_SUCCESS:
            return {
                ...state,
                isLoading: false,
                errorMessage: null,
                workflow: action.workflow
            };
        case STARTING_WORKFLOW_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                errorMessage: action.error.message,
                workflow: null
            };
        case DONE_BRICK:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false,
                errorMessage: null,
            };
        case DONE_BRICK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                errorMessage: null,
                workflow: action.workflow
            };
        case DONE_BRICK_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                errorMessage: action.error.message,
                workflow: null
            };
        case GET_BRICK_RESOURCES:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false,
                errorMessage: null,
            };
        case GET_BRICK_RESOURCES_SUCCESS:
            state.workflow.bricks = state.workflow.bricks.map(b => {
                if (b.id === action.brick_id)
                    b.resources = action.resources;
                return b;
            });
            return {
                ...state,
                isLoading: false,
                errorMessage: null,
            };
        case GET_BRICK_RESOURCES_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                errorMessage: action.error.message
            };
        default:
            return state;
    }
};

/* Export reducer */
export default (state = initialState, action) => {
    return applyReducers(state, action, [
        getReducer, listReducer, updateReducer, duplicateReducer,
        startCreateReducer, createReducer, deleteReducer,
        linkedResourcesReducer, reducer
    ]);
}

function startingWorkflow() { return { type: STARTING_WORKFLOW } }
function startingWorkflowSuccess(workflow) { return { type: STARTING_WORKFLOW_SUCCESS, workflow } }
function startingWorkflowFailure(err) { return { type: STARTING_WORKFLOW_FAILURE, error: err } }
const startWorkflowAction = (workflow_id, tkt_instance_id) => {
    return (dispatch) => {
        dispatch(startingWorkflow());
        Workflows.startWorkflow(workflow_id, tkt_instance_id)
            .then(data => {
                const { workflow } = data;
                dispatch(startingWorkflowSuccess(workflow));
            })
            .catch(err => {
                dispatch(startingWorkflowFailure(err))
            });
    }
};

function _doneBrick() { return { type: STARTING_WORKFLOW } }
function doneBrickSuccess(workflow) { return { type: STARTING_WORKFLOW_SUCCESS, workflow } }
function doneBrickFailure(err) { return { type: STARTING_WORKFLOW_FAILURE, error: err } }
const doneBrickAction = (workflow_id, tkt_instance_id, context, callback) => {
    return (dispatch) => {
        dispatch(_doneBrick());
        Workflows.doneBrick(workflow_id, tkt_instance_id, context)
            .then(data => {
                const { workflow } = data;
                dispatch(doneBrickSuccess(workflow));
                callback && callback(/*err*/null, workflow);
            })
            .catch(err => {
                dispatch(doneBrickFailure(err))
                callback && callback(err);
            });
    }
};

function gettingBrickResources() { return { type: GET_BRICK_RESOURCES } }
function gettingBrickResourcesSuccess(brick_id, resources) { return { type: GET_BRICK_RESOURCES_SUCCESS, brick_id, resources } }
function gettingBrickResourcesFailure(err) { return { type: GET_BRICK_RESOURCES_FAILURE, error: err } }
const getBrickResourcesAction = (workflow_id, tkt_instance_id, brick_id) => {
    return (dispatch) => {
        dispatch(gettingBrickResources());
        Workflows.getBrickResources(workflow_id, tkt_instance_id, brick_id)
            .then(data => {
                const { resources } = data;
                dispatch(gettingBrickResourcesSuccess(brick_id, resources));
            })
            .catch(err => {
                dispatch(gettingBrickResourcesFailure(err))
            });
    }
};

/* Export CRUD actions */
export const startCreateWorkflow         = startCreateAction;
export const createWorkflow              = createAction;
export const loadWorkflow                = getAction;
export const loadWorkflows               = listAction;
export const updateWorkflow              = updateAction;
export const deleteWorkflow              = deleteAction;
export const duplicateWorkflow           = duplicateAction;
export const startWorkflow               = startWorkflowAction;
export const doneBrick                   = doneBrickAction;
export const getBrickResources           = getBrickResourcesAction;
export const getWorkflowsLinkedResources = linkedResourcesAction;
